/* ============================================================
   Collective AD - Description Image Lightbox

   Intercepts clicks on <a class="fancybox"> wrappers inside the
   product description (a convention used by American Duchess to
   wrap size-chart images for fancybox.js, which HE doesn't load).

   Instead of letting the browser navigate to the raw image URL,
   we open the image in #collective-ad-lightbox (rendered by the
   collective-ad-description-tabs snippet), reusing HE's existing
   .size-chart-modal styles.

   Loaded conditionally from sections/he-product.liquid only when
   template.suffix == 'collective-ad' or description has [custom tab].
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var lightbox = document.getElementById('collective-ad-lightbox');
    if (!lightbox) return;

    var img = lightbox.querySelector('.collective-ad-lightbox__img');
    var title = lightbox.querySelector('.size-chart-title');
    var overlay = lightbox.querySelector('.size-chart-overlay');
    var closeBtn = lightbox.querySelector('.size-chart-close');
    var triggers = document.querySelectorAll('.product-description-content a.fancybox');

    if (!img || !triggers.length) return;

    var defaultTitle = title ? title.textContent : '';

    function open(href, alt) {
      img.src = href;
      img.alt = alt || '';
      if (title) title.textContent = alt || defaultTitle;
      lightbox.classList.add('active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-chart-modal-open');
    }

    function close() {
      lightbox.classList.remove('active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-chart-modal-open');
      img.src = '';
      img.alt = '';
      if (title) title.textContent = defaultTitle;
    }

    triggers.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var inner = a.querySelector('img');
        var alt = inner ? inner.alt : '';
        open(a.getAttribute('href'), alt);
      });
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('active')) {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
